import React, { useState, useEffect } from "react";
import { IconButton, Slide } from "@mui/material";
import { ExpandCircleDownRounded } from "@mui/icons-material";

export const BackToTopButton = () => {
  const [showButtonIn, setShowButtonIn] = useState(false);

  useEffect(() => {
    window.addEventListener("scroll", () => {
      if (window.scrollY > 100) {
        setShowButtonIn(true);
      } else {
        setShowButtonIn(false);
      }
    });
  }, []);

  const scrollUp = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <>
      {showButtonIn ? (
        <Slide in={showButtonIn} direction={"left"}>
          <IconButton
            aria-label="up"
            sx={{
              position: "fixed",
              bottom: "15px",
              right: "16px",
            }}
            onClick={scrollUp}
          >
            <ExpandCircleDownRounded
              sx={{
                color: "white",
                fontSize: "45px",
                transform: "rotate(180deg)",
              }}
            />
          </IconButton>
        </Slide>
      ) : (
        <Slide in={showButtonIn} direction={"left"}>
          <IconButton
            aria-label="up"
            sx={{
              position: "fixed",
              bottom: "15px",
              right: "16px",
            }}
            onClick={scrollUp}
          >
            <ExpandCircleDownRounded
              sx={{
                color: "white",
                fontSize: "45px",
                transform: "rotate(180deg)",
              }}
            />
          </IconButton>
        </Slide>
      )}
    </>
  );
};
